export default __webpack_public_path__ + "static/media/phone-call.aa9bbab1.webp";